import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext, useRef } from 'react';
import { axios } from '~/clients';
import { DISTANCE_CONTEXT } from '~/constants/endpoints';
import { useUserLocation } from '~/context/common/UserContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import { generateErrorLogger } from '~/utilities/loggers';

function useSendDeliveryMiles() {
  const { trackEvent } = useContext(AnalyticsContext);
  const isSubsequentRender = useRef(false);
  const { zip } = useUserLocation();
  const { location: { locationId } = {} } = useGetVehicleDetails();

  useEffectWithController(
    controller => {
      if (isSubsequentRender.current || !locationId || !zip) {
        return () => {};
      }

      isSubsequentRender.current = true;

      const t = setTimeout(() => {
        axios
          .get<{ locationDistances: Record<string, number> }>(
            `${DISTANCE_CONTEXT}?zip5=${zip}`,
            { signal: controller.signal }
          )
          .then(res => {
            const drivingMiles = res.data.locationDistances[locationId];

            trackEvent('Driving Miles', { drivingMiles, locationId, zip });
          })
          .catch(
            generateErrorLogger('Get distance context', {}, { controller })
          );
      }, 1000);

      return () => {
        clearTimeout(t);
      };
    },
    [locationId, trackEvent, zip]
  );
}

export default useSendDeliveryMiles;
